var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { Box } from '@creditas-ui/layout';
import { styled } from '@creditas-ui/system'; // Hide checkbox visually but remain accessible to screen readers.
// Source: https://polished.js.org/docs/#hidevisually

var HiddenCheckbox = styled(Box.withComponent('input', process.env.NODE_ENV === "production" ? {
  target: "eo56rgf0"
} : {
  target: "eo56rgf0",
  label: "HiddenCheckbox"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  clip-path: inset(50%);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n"])));
HiddenCheckbox.defaultProps = {
  type: 'checkbox'
};
export { HiddenCheckbox };
//# sourceMappingURL=HiddenCheckbox.js.map